var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckmarkSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM16.7347 9.67841C17.1094 9.27265 17.0842 8.63999 16.6784 8.26532C16.2727 7.89064 15.64 7.91583 15.2653 8.32159L10.3756 13.6169L8.68298 12.0343C8.27957 11.6571 7.64677 11.6783 7.26957 12.0817C6.89236 12.4851 6.91361 13.1179 7.31702 13.4951L9.74464 15.765C9.93915 15.9469 10.1982 16.0437 10.4643 16.0339C10.7304 16.0242 10.9816 15.9087 11.1623 15.713L16.7347 9.67841Z",
    fill: "#2A9864"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckmarkSolid);
export default __webpack_public_path__ + "static/media/circle-checkmark-solid.a744507f6497068b03f8d5ec83aba9ec.svg";
export { ForwardRef as ReactComponent };